import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class ModulesService {
  getModules() {
    return ApiService.get(`${Config.api.auth.url}modules`, {}).then((response) => response.data);
  }

  // ----- Admin -----
  getTenantModules() {
    return ApiService.get(`${Config.api.auth.url}tenants/current/modules`, {})
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  setTenantModule({ tenantId, moduleId, hasAccess }) {
    const data = {
      tenantId,
      moduleId,
      hasAccess,
    };

    return ApiService.put(`${Config.api.auth.url}tenants/current/modules/${moduleId}`, data)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
}

export const modulesService = new ModulesService();
